import apiService from '@/services/apiService';

const actions = {
  getEvent({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxelian-club/event/find-with-paging', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postEvent({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxelian-club/event', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postActivation({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post(`paxelian-club/event/activation/${payload.id}`, payload.data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putEvent({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`paxelian-club/event/${payload.id}`, payload.data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },


};

export default actions;